<template>
  <section class="hero has-hero-image is-between-small-and-medium">
    <div id="hero_image" :style="'background-image: url(' + $store.state.hero_uri + ')'"></div>
    <router-link id="logo" to="/" v-if="$store.state.logo_uri" aria-label="Home">
      <img class="logo" :src="$store.state.logo_uri" alt="Directory Hero">
    </router-link>
    <div class="hero-body">
      <div class="has-text-centered columns is-multiline is-vcentered">
        <div class="column is-12">
          <h1 class="title is-size-2 has-text-white" v-if="$store.state.hero_text">
            {{ $store.state.hero_text }}
          </h1>
        </div>
        <div class="column is-12">
          <nav class="buttons has-text-centered is-centered">
            <router-link
              :to="`/${directory.slug}`"
              class="button is-white has-text-weight-bold is-medium"
              v-for="directory in $store.getters.directories"
              :key="directory.id"
            >
              {{ directory.name.toUpperCase() }}
            </router-link>
          </nav>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
};
</script>
